
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-balcony-solar-system/support",
      function () {
        return require("private-next-pages/stream-balcony-solar-system/support/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-balcony-solar-system/support"])
      });
    }
  